import _get from "lodash/get";

/**
 Redux selectors that have to do with errors
 */

/**
 * Return whether the user access token is valid (did we see an error 401 in any of the services?)
 * @param {*} state
 * @returns {boolean}
 */
export const getAccessTokenInvalid = (state) => {
    const status1is401 = _get(state, "newsletters.newslettersError.responseStatus") == 401;
    const status2is401 = _get(state, "newsletters.archivesError.responseStatus") == 401;
    const status3is401 = _get(state, "newsletters.currentDataError.responseStatus") == 401;
    // console.log(status2is401, status1is401, status3is401)
    return status1is401 || status2is401 || status3is401;
};


/**
 * Get the error message (code) associated with the "get current data" service
 * @param state
 * @returns {string}
 */
export const getCurrentDataErrorCode = (state) => {
    return _get(state, "newsletters.currentDataError.errorMsg", "");
};

/**
 * Get whether or not we are currently loading newsletter data
 * @param state
 * @returns {boolean}
 */
export const getCurrentDataIsLoading = (state) => {
    return _get(state, "newsletters.isLoadingNewsletterData", false);
};

/**
 * Get the "get current data" service returned "newsletter not found"
 * @param state
 * @returns {boolean}
 */
export const getCurrentDataErrorNewsletterNotFound = (state) => {
    return getCurrentDataErrorCode(state) == "NEWSLETTER_NOT_FOUND";
};

/**
 * Get the "get current data" service returned "edition not found"
 * @param state
 * @returns {boolean}
 */
export const getCurrentDataErrorEditionNotFound = (state) => {
    return getCurrentDataErrorCode(state) == "EDITION_NOT_FOUND";
};


/**
 *  Get the error message (in HTML text) to be shown to the content pane
 * @param state
 * @returns {*}
 */
export const getContentPaneErrorHTML = (state) => {
    const mailLink = `<a href='mailto:help@publicrelay.com?subject=Newsletter%20Access%20Issue&body=Hello%20-%20I%20cannot%20currently%20view%20my%20newsletter%20on%20the%20newsreader%20platform.%20Can%20you%20please%20help?'>here</a>`
    if(getAccessTokenInvalid(state)){
        return `You are not currently authorized to view this newsletter. If you should have access, please wait a few minutes and try again. If the issue persists, please contact PublicRelay ${mailLink}.`
    } else if(getCurrentDataErrorNewsletterNotFound(state)){
        return `The newsletter you are trying to access is no longer available. If the newsletter was recently sent to you, please wait a few minutes and try again. If the issue persists, please contact PublicRelay ${mailLink}.`
    } else if(getCurrentDataErrorEditionNotFound(state)){
        return `The edition you are trying to access does not exist. If the newsletter was recently sent to you, please wait a few minutes and try again. If the issue persists, please contact PublicRelay ${mailLink}.`
    } else {
        return `The newsletter you are trying to access is no longer available. If the newsletter was recently sent to you, please wait a few minutes and try again. If the issue persists, please contact PublicRelay ${mailLink}.`
    }
};
